import config from 'services/config'

const certificateFunctions = require('@/services/certificateCreation/languages/certificateFunctions_' + config.appLanguage + '.js').default

const actions = {
    async createCertificate (store, certificate) {
        certificateFunctions.createSingleCertificate(certificate)
    },
    async createListCertificate (store, filteredCertificates) {
        certificateFunctions.createListCertificate(filteredCertificates)
    }
}

export default {
    namespaced: true,
    actions
}
